export class StorageUtil {
  static get<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch {
      const item = localStorage.getItem(key);
      return item as unknown as T;
    }
  }

  static set<T>(key: string, value: T): void {
    localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
  }

  static remove(key: string): void {
    localStorage.removeItem(key);
  }

  static clear(): void {
    localStorage.clear();
  }
}
